import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useIdleTimer } from 'react-idle-timer';
import { logout } from '../../utils/auth';
import SidebarV2 from './SidebarV2';
import HeaderV2 from './HeaderV2';

export default function BaseV2({ children }) {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Auto-close mobile drawer on navigation
  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  // Lock body scroll when mobile drawer is open to prevent background scrolling
  useEffect(() => {
    if (mobileOpen) {
      const originalOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalOverflow;
      };
    }
  }, [mobileOpen]);

  // Close mobile drawer on Escape key
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'Escape' && mobileOpen) {
        setMobileOpen(false);
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [mobileOpen]);

  const onIdle = () => {
    logout();
  };

  useIdleTimer({
    onIdle,
    timeout: 600000,
    throttle: 500,
  });

  const handleToggleSidebar = () => {
    if (typeof window !== 'undefined' && window.innerWidth < 768) {
      setMobileOpen((prev) => !prev);
    } else {
      setCollapsed((prev) => !prev);
    }
  };

  return (
    <div className="v2-app">
      <div className="v2-shell">
        {/* Mobile Backdrop Scrim */}
        {mobileOpen && (
          <div
            className="v2-sidebar-backdrop"
            onClick={() => setMobileOpen(false)}
            aria-label="Cerrar menú"
          />
        )}

        <SidebarV2
          collapsed={collapsed}
          mobileOpen={mobileOpen}
          onCloseMobile={() => setMobileOpen(false)}
          onToggleCollapse={() => setCollapsed(!collapsed)}
        />

        <div className="v2-main-wrapper">
          <HeaderV2
            sidebarCollapsed={collapsed}
            mobileOpen={mobileOpen}
            onToggleSidebar={handleToggleSidebar}
          />
          <main className="v2-content">
            {children}
          </main>
        </div>
      </div>
    </div>
  );
}
